
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-07-12-r3f-sky-dome",
      function () {
        return require("private-next-pages/blogs/2025-07-12-r3f-sky-dome/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-07-12-r3f-sky-dome"])
      });
    }
  